export const TEAMS_SESSION_ID = 'isInTeams';

// Time durations (milliseconds)
export const HOUR_IN_MS = 60 * 60 * 1000;
export const DEFAULT_WORKING_DAY_MS = 9 * HOUR_IN_MS;
export const STATE_RESET_TIMEOUT = 5000;
export const NOTIFICATION_TIMEOUT = 4000;
export const INCOMPLETE_SESSION_REFETCH_DELAY = 3000;
export const DATE_DISPLAY_INTERVAL = 1000;
export const PROCESSING_DEBOUNCE = 200;
